import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useUrlQuery } from '../../utils/hooks';
import Logo from '../icons/Logo';

const SplitView = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  width: 100%;
  height: 100%;
  overflow: scroll;
`;

const Content = styled.div`
  position: relative;
  width: 350px;
  margin: 5rem auto;
  h1 {
    margin-bottom: 2rem;
    font-size: 1rem;
  }
  h2 {
    margin-bottom: 1rem;
  }
  form {
    padding: 0;
  }
  .form-group {
    width: 100%;
    margin-right: 0;
  }
  button[type='submit'] {
    width: 100%;
    display: block;
  }
`;

const LogoLink = styled(Link)`
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
`;

const FullsizeImage = styled.div`
  width: 100%;
  height: 100%;
  background-color: #336600;
  background-image: url('${({ path }) => path}');
  background-position: center;
  background-size: cover;
`;

const OnboardingLayout = ({ image, children }) => {
  const queryParams = useUrlQuery();
  const backPath = queryParams.get('backPath');
  return (
    <SplitView>
      <LogoLink to={backPath || '/app/my-projects'}>
        <Logo width={20} height={20} />
      </LogoLink>
      <Content>{children}</Content>
      <FullsizeImage path={image} />
    </SplitView>
  );
};

export default OnboardingLayout;
